export function computingTime() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
        month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    var currentdate = year + "-" + month + "-" + day;
    var value2 = currentdate;
    var value1 = year + "-" + "01" + "-" + "01";
    return { value1, value2 };

}